import { Checkbox, Touchable } from '@/components'
import { Chat } from '@/config/packages'
import { createStyles } from '@codeleap/styles'
import { shouldShowMessageCheckbox } from '@packages/chat'
import { useMessageContext } from 'stream-chat-react'
import { MessageProps } from '../types'

type MessageCheckboxProps = MessageProps & {
  isChecked?: boolean
  onClick: () => void
  isSelected?: boolean
}

export const MessageCheckboxWithContext = ({ onClick, isChecked }: MessageCheckboxProps) => {

  return (
    <Touchable
      debugName='MessageCheckbox'
      style={styles.wrapper}
      onPress={onClick}
    >
      <Checkbox
        style={['circle']}
        value={isChecked}
        onValueChange={onClick}
      />
    </Touchable>
  )
}

const styles = createStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing.value(2),
    cursor: 'pointer',
    pointerEvents: 'auto',
    alignSelf: 'center',
  },
}))

export const MessageCheckbox = ({ onClick, isSelected, ...props }: MessageCheckboxProps) => {
  const { selectModeActive } = Chat.Store.useSelectMode({ threadList: props.threadList })
  const selectMode = Chat.Store.state.use(s => s.selectMode)
  const { message } = useMessageContext()

  const show = shouldShowMessageCheckbox({
    message,
    selectMode,
    selectModeActive,
    isMyMessage: !!props?.isMyMessage?.(),
    threadList: !!props.threadList,
  })
  if (!show) return null

  return <MessageCheckboxWithContext {...props} onClick={onClick} isChecked={isSelected} />
}
